export const JOB_ORDER_DRAFTS_COLUMNS = [
  {
    name: 'id',
    options: { filter: false, display: 'excluded' }
  },
  {
    name: 'title',
    label: 'Job Order',
    options: { filter: true, display: true }
  },
  {
    name: 'companyName',
    label: 'Company',
    options: { filter: true, display: true }
  },
  {
    name: 'updatedAt',
    label: 'Last Update',
    options: { sort: true, display: true, renderer: 'date' }
  },
  {
    name: 'createdAt',
    label: 'Created At',
    options: { sort: true, display: true, renderer: 'date' }
  },
  {
    name: 'legacyId',
    options: { filter: false, display: 'excluded' }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'updatedAt',
  direction: 'desc'
};
